/**
 * Schritt 4: Modellvergleich: Einkommensteuer vs. Abgeltungsteuer (Beispielrechnung)
 * Vergleicht Kapitalertragsteuer mit individueller Einkommensteuer nach § 32d Abs. 6 EStG
 */

import React from 'react';
import {
  Container,
  Header,
  SpaceBetween,
  Alert
} from '@cloudscape-design/components';

import { PortfolioPosition, EntnahmeSimulation, SteuerParameter } from '@/types';
import GuenstigerpruefungTab from '@/components/GuenstigerpruefungTab';

interface Schritt4Props {
  portfolioPositionen: PortfolioPosition[];
  entnahmeSimulation: EntnahmeSimulation | null;
  hatVerkaufsEingaben: boolean;
  steuerParameter: SteuerParameter | null;
  jahreseinkommen: string;
  sonderausgaben: string;
  onJahreseinkommenUpdate: (jahreseinkommen: string) => void;
  onSonderausgabenUpdate: (sonderausgaben: string) => void;
  sparerPauschbetragEnabled: boolean;
}

/**
 * Hauptkomponente für Schritt 4: Modellvergleich
 */
const Schritt4: React.FC<Schritt4Props> = ({
  portfolioPositionen,
  steuerParameter,
  jahreseinkommen,
  sonderausgaben,
  onJahreseinkommenUpdate,
  onSonderausgabenUpdate,
  sparerPauschbetragEnabled
}) => {
  return (
    <Container
      header={
        <Header
          variant="h2"
          description="Nur zur Veranschaulichung; keine Steuerberatung."
        >
          Modellvergleich: Einkommensteuer vs. Abgeltungsteuer (Beispielrechnung) auf Basis der für 2026 gültigen Regelungen
        </Header>
      }
    >
      <SpaceBetween direction="vertical" size="l">
        {/* Wichtiger Hinweis */}
        <Alert type="warning">
          <strong>Wichtiger rechtlicher Hinweis:</strong>
          <br />
          Diese Anwendung wird ohne Gewähr zur Verfügung gestellt. Alle Berechnungen und Steuerhinweise dienen ausschließlich zur Information und stellen selbstverständlich keine Steuerberatung dar. Sie ersetzen keine professionelle Steuerberatung. Jeder Nutzer ist selbstverantwortlich für die Verwendung der Ergebnisse und sollte bei steuerlichen Entscheidungen einen qualifizierten Steuerberater konsultieren.
        </Alert>

        {/* Hauptinhalt: Modellvergleich */}
        <GuenstigerpruefungTab
          portfolioPositionen={portfolioPositionen.filter(p => !p.exclude && p.sellPercentage > 0)}
          steuerParameter={steuerParameter}
          jahreseinkommen={jahreseinkommen}
          sonderausgaben={sonderausgaben}
          onJahreseinkommenUpdate={onJahreseinkommenUpdate}
          onSonderausgabenUpdate={onSonderausgabenUpdate}
          sparerPauschbetragEnabled={sparerPauschbetragEnabled}
        />
      </SpaceBetween>
    </Container>
  );
};

export default Schritt4;